import { maskCpf, maskCrp, maskTel } from '../../../../utils'
import { Input, SelectInput } from '../../../../components'
import TitleCard from '../TitleCard'

import * as S from './styles'

const DataCard = ({ data, setData }: any) => (
  <div>
    <TitleCard title="Dados" />
    <S.InputContainer>
      <Input
        labelColor="#4F4F4F"
        label="Nome completo*"
        name="name"
        type="text"
        required={true}
        maxLength={150}
        onChange={(e: any) =>
          setData((prev: any) => ({
            ...prev,
            usuario: {
              ...prev.usuario,
              nome: e.target.value
            }
          }))
        }
        value={data?.usuario?.nome}
      />
      <Input
        labelColor="#4F4F4F"
        label="E-mail*"
        name="email"
        type="email"
        required={true}
        maxLength={100}
        value={data?.usuario?.email}
        disabled
      />
      <Input
        labelColor="#4F4F4F"
        label="CPF*"
        name="cpf"
        type="text"
        required={true}
        maxLength={14}
        onChange={(e: any) =>
          setData((prev: any) => ({
            ...prev,
            cpf: e.target.value
          }))
        }
        value={maskCpf(data?.cpf)}
      />
      <Input
        labelColor="#4F4F4F"
        label="Telefone*"
        name="tel"
        required={true}
        type="tel"
        onChange={(e: any) =>
          setData((prev: any) => ({
            ...prev,
            contato: {
              ...prev.contato,
              contato: e.target.value
            }
          }))
        }
        maxLength={15}
        value={maskTel(data?.contato?.contato)}
      />
      <Input
        labelColor="#4F4F4F"
        label="Documento Profissional (CRP)"
        name="document"
        type="text"
        onChange={(e: any) =>
          setData((prev: any) => ({
            ...prev,
            crp: e.target.value
          }))
        }
        maxLength={10}
        value={maskCrp(data?.crp)}
      />
      <SelectInput
        labelColor="#4F4F4F"
        label="Sexo/Gênero"
        name="sexo"
        hasSelectOption={false}
        options={[
          { value: '', label: '' },
          { value: 'Masculino', label: 'Masculino' },
          { value: 'Feminino', label: 'Feminino' }
        ]}
        onChange={(e: any) =>
          setData((prev: any) => ({
            ...prev,
            sexo: e.target.value
          }))
        }
        value={data?.sexo}
      />
    </S.InputContainer>
  </div>
)

export default DataCard
